// iron-mass.js
import React, { useState } from "react";
import MainCalculatorsList from "./MainCalculators";
import SharedHelmet from ".././Helmet";
import RelatedLinks from "../RelatedLinks";
import { FirstAds, SecondAds,MobileUnderCalAds } from "../../Ads";
const TITLE = "Kalkulator Massa Besi - Hitung Massa Besi";
const DESCRIPTION =
    "Kalkulator massa besi yang akurat: Hitung berat potongan besi (dalam kilogram atau ton) melalui dimensi (panjang, lebar, tinggi) atau volume! Ideal untuk insinyur, manufaktur, dan material konstruksi - dengan mempertimbangkan kepadatan standar besi.";
const KEYWORDS = "massa besi, hitung massa besi, kalkulator massa besi";
const OG_URL = "https://do-calculate.com/calculator/id/iron-mass/";
function Calculator() {
    const [density, setDensity] = useState(7.8);
    const [length, setLength] = useState('');
    const [width, setWidth] = useState('');
    const [height, setHeight] = useState('');
    const [volume, setVolume] = useState('');
    const [ironMass, setIronMass] = useState('');
    const [error, setError] = useState('');
    const handleCalculate = () => {
        if (!length || !width || !height) {
            setError('Harap masukkan dimensi dengan benar');
            setVolume('');
            setIronMass('');
            return;
        }
        const lengthValue = parseFloat(length);
        const widthValue = parseFloat(width);
        const heightValue = parseFloat(height);
        if (isNaN(lengthValue) || isNaN(widthValue) || isNaN(heightValue) || lengthValue <= 0 || widthValue <= 0 || heightValue <= 0) {
            setError('Harap masukkan nilai dimensi yang valid dan positif');
            setVolume('');
            setIronMass('');
            return;
        }
        const ironVolume = lengthValue * widthValue * heightValue;
        setVolume(ironVolume.toFixed(2));
        const mass = ironVolume * density;
        setIronMass(mass.toFixed(2));
        setError('');
    };
    return (
        <div>
            <SharedHelmet TITLE={TITLE} DESCRIPTION={DESCRIPTION} KEYWORDS={KEYWORDS} OG_URL={OG_URL} />
            <div className="row">
                <div className="col-12 col-md-8">
                    <FirstAds />
                </div>
            </div>
            <div className="row">
                <div className="col-12 col-md-8">
                    <br />
                    <div className="bg-success text-white text-center" style={{ height: '40px' }}>
                        <h1 style={{ fontSize: '17px' }}>{TITLE}</h1>
                    </div>
                    <div className="border border-light">
                        <div className="row">
                            <div>
                                <h2 style={{ fontSize: '18px' }}>Cara Menghitung Massa Besi</h2>
                                <p>
                                    Kalkulator massa besi menggunakan rumus untuk menghitung berat besi, yang didasarkan pada persamaan berikut:
                                </p>
                                <p>
                                    Berat = Massa Jenis × Volume
                                </p>
                                <p>
                                    Dalam rumus ini, berat adalah jumlah besi yang dibutuhkan (dalam gram), dan massa jenis besi biasanya adalah 7,8 g/cm³.
                                </p>
                                <p>
                                    Untuk melakukan perhitungan, Anda harus memasukkan dimensi potongan besi (panjang, lebar, dan tinggi) untuk menentukan volume. Setelah itu, kalkulator akan menghitung berat berdasarkan massa jenis dan volume.
                                </p>
                                <hr />
                            </div>
                        </div>
                        <MobileUnderCalAds />
                        <div className="row">
                            <div className="col-sm-12 col-md-7 calculatorStyle">
                                <div className='p-3 mb-2 bg-success text-white'>
                                    <h2 style={{ fontSize: '16px' }}>{TITLE} </h2>
                                </div>
                                <hr />
                                <div >
                                    <div>
                                        <div className="form-group d-flex align-items-center">
                                            <b>
                                                <label className="form-label ms-2">Panjang (cm)</label>
                                            </b>
                                            <input
                                                type="number"
                                                placeholder="Panjang"
                                                value={length}
                                                onChange={(e) => setLength(e.target.value)}
                                                className="form-control"
                                                style={{ width: '150px' }}
                                            />
                                        </div>
                                        <br />
                                        <div className="form-group d-flex align-items-center">
                                            <b>
                                                <label className="form-label ms-2">Lebar (cm)</label>
                                            </b>
                                            <input
                                                type="number"
                                                placeholder="Lebar"
                                                value={width}
                                                onChange={(e) => setWidth(e.target.value)}
                                                className="form-control"
                                                style={{ width: '150px' }}
                                            />
                                        </div>
                                        <br />
                                        <div className="form-group d-flex align-items-center">
                                            <b>
                                                <label className="form-label ms-2">Tinggi (cm)</label>
                                            </b>
                                            <input
                                                type="number"
                                                placeholder="Tinggi"
                                                value={height}
                                                onChange={(e) => setHeight(e.target.value)}
                                                className="form-control"
                                                style={{ width: '150px' }}
                                            />
                                        </div>
                                        <br />
                                        <button
                                            className="btn btn-success"
                                            style={{ fontSize: '20px' }}
                                            onClick={handleCalculate}
                                        >
                                            Hitung Massa Besi
                                        </button>
                                    </div>
                                    <br />
                                    <div>
                                        {error !== '' ? (
                                            <p className='p-3 mb-2 bg-warning text-white'>Error: {error}</p>
                                        ) : (
                                            <>
                                                {ironMass !== '' && (
                                                    <p className='p-3 mb-2 bg-success text-white'>
                                                        Massa Besi: {ironMass} g
                                                    </p>
                                                )}
                                                {volume !== '' && (
                                                    <p className='p-3 mb-2 bg-success text-white'>
                                                        Volume Besi: {volume} cm³
                                                    </p>
                                                )}
                                            </>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <hr />
                        <div className="row">
                            <RelatedLinks />
                            <hr />
                        </div>
                    </div>
                </div>
                <div className="col">
                    <SecondAds />
                    <br />
                    <MainCalculatorsList />
                    <br />
                </div>
            </div>
            <div className="col-12 col-md-8">
                <div className="info-sections-container">
                    <div className="info-section">
                        <div className="info-section-header">
                            <h2 style={{ fontSize: "18px" }}>{TITLE}</h2>
                        </div>
                        <div className="info-section-body">
                            <p>{DESCRIPTION}</p>
                            <div>
                                <h3 style={{ fontSize: '16px' }}>Cara Menghitung Massa Besi</h3>
                                <p>Kalkulator massa besi didasarkan pada rumus berikut untuk menghitung massa:</p>
                                <p><strong>Massa = Massa Jenis × Volume</strong></p>
                                <p>Dalam rumus ini, massa adalah berat potongan besi (dalam gram), dan massa jenis besi biasanya 7,8 g/cm³.</p>
                                <p>Untuk menghitung massa secara akurat, Anda harus memasukkan tiga dimensi (panjang, lebar, dan tinggi) dari potongan tersebut. Kalkulator akan menghitung volume berdasarkan dimensi ini, kemudian menggunakan massa jenis untuk menghitung berat total.</p>
                            </div>
                            <hr />
                            <div>
                                <h3 style={{ fontSize: '16px' }}>Cara Menggunakan Kalkulator Massa Besi</h3>
                                <p>Untuk menggunakan Kalkulator Massa Besi secara efektif, masukkan nilai yang tepat untuk panjang, lebar, dan tinggi di kolom yang disediakan. Setelah memasukkan nilai-nilai ini, kalkulator akan menghitung volume terlebih dahulu menggunakan rumus:</p>
                                <p><strong>Volume = Panjang × Lebar × Tinggi</strong></p>
                                <p>Kemudian menggunakan massa jenis standar besi (7,8 g/cm³) untuk menentukan massa akhir.</p>
                            </div>
                            <hr />
                            <div>
                                <h3 style={{ fontSize: '16px' }}>Contoh Perhitungan Massa Besi</h3>
                                <p>Misalkan Anda memiliki sepotong besi dengan dimensi:</p>
                                <div className='p-3 mb-2 bg-info'>
                                    <strong>Panjang:</strong> 12 cm <br />
                                    <strong>Lebar:</strong> 4 cm <br />
                                    <strong>Tinggi:</strong> 3 cm
                                </div>
                                <p>Untuk menghitung volume, kita terapkan rumus:</p>
                                <p><strong>Volume = Panjang × Lebar × Tinggi = 12 cm × 4 cm × 3 cm = 144 cm³</strong></p>
                                <p>Untuk menghitung massa menggunakan massa jenis, kita terapkan rumus berikut:</p>
                                <p><strong>Massa = Massa Jenis × Volume = 7,8 g/cm³ × 144 cm³ = 1123,2 g</strong></p>
                                <div className='p-3 mb-2 bg-info text-black'>
                                    Jadi, massa akhir potongan tersebut adalah 1123,2 g.
                                </div>
                            </div>
                            <hr />
                            <div>
                                <h3 style={{ fontSize: '16px' }}>Tips Menghitung Massa Besi</h3>
                                <p>Untuk memastikan perhitungan yang akurat, pastikan untuk memasukkan dimensi dengan tepat. Anda juga harus menggunakan massa jenis besi yang sesuai dengan jenis besi yang Anda gunakan. Untuk informasi lebih lanjut tentang sifat-sifat besi dan massa jenisnya, Anda dapat merujuk pada sumber-sumber berikut:</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
export default Calculator;